import React from 'react';
import { ListenedRelease } from '../types';
import { formatRelativeTime } from '../utils/formatRelativeTime';

interface HistoryListItemProps {
  release: ListenedRelease;
  onUnlisten: (releaseId: number) => void;
  isProcessing: boolean;
}

const HistoryListItem: React.FC<HistoryListItemProps> = ({
  release,
  onUnlisten,
  isProcessing
}) => {
  return (
    <div className="flex items-center gap-4 p-3 hover:bg-gray-50 rounded-lg transition-colors border-b border-gray-100 last:border-b-0">
      {/* Thumbnail - clickable to Bandcamp */}
      <a
        href={release.release_url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0"
      >
        <img
          src={release.image_url}
          alt={release.title}
          className="w-14 h-14 rounded object-cover shadow-sm hover:opacity-80 transition-opacity cursor-pointer"
        />
      </a>

      {/* Release Info - clickable to Bandcamp */}
      <a
        href={release.release_url}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 min-w-0 hover:opacity-80 transition-opacity"
      >
        <h3 className="font-semibold truncate text-gray-900">{release.title}</h3>
        <p className="text-sm text-gray-600 truncate">{release.artist}</p>
      </a>

      {/* Label (hidden on mobile, shown on tablet+) */}
      <div className="hidden md:block text-sm text-gray-700 max-w-[150px] truncate">
        <a
          href={release.label_url}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-green-600 hover:underline"
          title={release.label_name}
        >
          {release.label_name}
        </a>
      </div>

      {/* Timestamp */}
      <div className="text-sm text-gray-500 whitespace-nowrap hidden sm:block">
        {formatRelativeTime(release.listened_at)}
      </div>

      {/* Remove Button */}
      <div className="flex-shrink-0">
        <button
          onClick={() => onUnlisten(release.id)}
          disabled={isProcessing}
          className="px-3 py-1.5 text-sm rounded-md bg-red-50 text-red-600 hover:bg-red-100 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap border border-red-200"
        >
          {isProcessing ? 'Removing...' : 'Remove'}
        </button>
      </div>
    </div>
  );
};

export default HistoryListItem;
